import { Box, IconButton } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function BackToTop() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 16, sm: 20, md: 24 },   // ✅ responsive spacing
        right: { xs: 16, sm: 20, md: 24 },    // ✅ responsive spacing
        zIndex: 1300,
      }}
    >
      <IconButton
        onClick={scrollToTop}
        aria-label="Back to top"
        sx={{
          width: { xs: 38, sm: 40, md: 42 },  // ✅ responsive size
          height: { xs: 38, sm: 40, md: 42 },
          backgroundColor: "#ffffff",
          border: "1px solid #2d2075",
          borderRadius: "4px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
          color: "#2d2075",
          transition: "all 0.3s ease",

          "&:hover": {
            backgroundColor: "#2d2075",
            color: "#ffffff",
            transform: "translateY(-2px)",   // ✅ subtle professional hover
          },
        }}
      >
        <KeyboardArrowUpIcon
          sx={{
            fontSize: { xs: 20, sm: 22, md: 24 }, // ✅ responsive icon
          }}
        />
      </IconButton>
    </Box>
  );
}
